import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const EqualSmallIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/equal-small"><g id="Icon"><path d="M7.9 8.6001C7.40294 8.6001 7 9.00304 7 9.5001C7 9.99715 7.40294 10.4001 7.9 10.4001H16.1C16.5971 10.4001 17 9.99715 17 9.5001C17 9.00304 16.5971 8.6001 16.1 8.6001L7.9 8.6001Z" fill="currentColor" /><path d="M7.9 13.6001C7.40294 13.6001 7 14.003 7 14.5001C7 14.9972 7.40294 15.4001 7.9 15.4001H16.1C16.5971 15.4001 17 14.9972 17 14.5001C17 14.003 16.5971 13.6001 16.1 13.6001H7.9Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default EqualSmallIcon;